var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-items',{staticClass:"hidden-xs-only"},[(_vm.user!==null)?_c('app-user-avatar',{key:_vm.avatarKey}):_c('app-login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }